<button matIconButton type="button" class="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
@if (data.title) {
  <h4 mat-dialog-title [innerHTML]="data.title">
  </h4>
}
@if (data.text) {
  <div mat-dialog-content>
    <p [innerHTML]="data.text"></p>
  </div>
}
<!-- <div mat-dialog-actions>
<button mat-stroked-button mat-dialog-close cdkFocusInitial>{{ (data.cancelLabel ? (data.cancelLabel | uppercase): ("trace.close-panel"| translate | uppercase)) }}</button>
<button mat-stroked-button [mat-dialog-close]="{data}">{{ (data.continueLabel ? (data.continueLabel | uppercase) : "OK") }}</button>
</div> -->
<mat-dialog-actions align="center" class=""  cdkTrapFocus [cdkTrapFocusAutoCapture]="true" >
  <div class="button-container">
    <!-- <div class="form-element"> -->
    <button mat-flat-button color="primary" [mat-dialog-close]="{data}" cdkFocusInitial>{{ (data.continueLabel ? (data.continueLabel ) : "Ok") }}</button>
  <!-- </div> -->
</div>
<div class="button-container">
  <a mat-button mat-dialog-close class="close-tip">{{ (data.cancelLabel ? (data.cancelLabel | uppercase): ("general.cancel"| translate )) }}</a>
</div>
</mat-dialog-actions>